// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #000000;
  --color-white: #ffffff;
  --color-red: #ff0000;
  --color-blue: #00a2ed;
  --color-secondary: rgb(34, 34, 34);
  --font-white: rgb(250, 249, 248);
  --font-light-grey: #a4a4a4;
  --font-medium: 18px !important;
  --medium-screen: 640px !important;
  --small-screen: 960px; }

.SignInOverlay {
  background: rgba(0, 0, 0, 0.25);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px); }

h1 {
  color: black;
  -webkit-text-fill-color: white;
  /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/components/lockScreen/lockScreen.scss"],"names":[],"mappings":"AAAA;EACC,wBAAgB;EAChB,sBAAc;EACd,oBAAY;EACZ,qBAAa;EACb,kCAAkB;EAElB,gCAAa;EACb,0BAAkB;EAElB,8BAAc;EAEd,iCAAgB;EAChB,qBAAe,EAAA;;ACXhB;EACC,+BAA+B;EAC/B,gDAAgD;EAChD,0BAA0B;EAC1B,kCAAkC,EAAA;;AAGnC;EACE,YAAY;EACZ,8BAA8B;EAAE,8CAAA;EAChC,8BAA8B;EAC9B,gCAAgC,EAAA","sourcesContent":[":root {\n\t--color-primary: #000000;\n\t--color-white: #ffffff;\n\t--color-red: #ff0000;\n\t--color-blue: #00a2ed;\n\t--color-secondary: rgb(34, 34, 34);\n\n\t--font-white: rgb(250, 249, 248);\n\t--font-light-grey: #a4a4a4;\n\n\t--font-medium: 18px !important;\n\n\t--medium-screen: 640px !important;\n\t--small-screen: 960px;\n}\n","@import \"../../theme/variables\";\n\n.SignInOverlay {\n\tbackground: rgba(0, 0, 0, 0.25);\n\tbox-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n\tbackdrop-filter: blur(4px);\n\t-webkit-backdrop-filter: blur(4px);\n}\n\nh1 {\n  color: black;\n  -webkit-text-fill-color: white; /* Will override color (regardless of order) */\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
